export const chartMixins = {
  methods: {
    // Adds '%' to the end of each hover tooltip value
    formatLabelAsPercent: function (label) {
      return label ? `${label}%` : ''
    },

    setData: function (props) {
      return props.dataAndLabelsArray.length
        ? props.dataAndLabelsArray?.map(([_label, value]) => value)
        : props.data
    },

    setLabels: function (props) {
      return props.dataAndLabelsArray.length
        ? props.dataAndLabelsArray?.map(([label, _value]) => label)
        : props.labels
    }
  }
}
